import { pageNames } from "utils/Types";
import { noPlansMessageCommon } from "./NoPlansMessageCommon";

export const noPlansMessage = {
  ...noPlansMessageCommon,
  [pageNames.suggested]: {
    label: "Suggested",
    title: "You have no suggested plans for your Wizard selections.",
    content: "You can retake the Wizard or see the plans below.",
    showButton: true
    // image: AllCheckSuggestion
  },
  [pageNames.noSuggestedFilter]: {
    label: "All Plans",
    title: "No additional suggested plans are available - that's okay.",
    content: "You can retake the Wizard or search the Library.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.myPlans]: {
    label: "myPlans",
    title: "Hey! You have no plans added.",
    content:
      "No problem! To get started, go to My Dashboard, search the Library, or retake the Wizard to find your biggest opportunities.",
    showButton: true,
    buttonLabel: "Explore Plans"
    // image: PersonSearch
  },
  [pageNames.noActivePlans]: {
    label: "onBoardingSuggestions",
    title: "Your onboarding is 100% complete",
    content: "Based on your current preferences we found some suggestions for you.",
    showButton: true,
    buttonLabel: "See Suggested plans"
    // image: PersonSearch
  },
  [pageNames.noAssignAction]: {
    label: "onBoardingAssign",
    content: "Ready to assign your first action?",
    showButton: true,
    buttonLabel: "Assign Action"
    // image: DiverseTeam
  },
  [pageNames.noReports]: {
    label: "CompletedPlanReports",
    title: `You have no Completed Plans`,
    showButton: false
    // image: PersonSearch
  },
  [pageNames.searchResultAction]: {
    label: "Individual Actions",
    title: "There are no actions for this Functional Areas.",
    content: "We are always adding the most relevant content for you so continue to check back or retake the Wizard.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.globalSearchResult]: {
    label: "Global Search",
    title: "Oh no! No actions were found with these words.",
    content: "Try different key terms, continue to check back, or retake the wizard.",
    showButton: false
    // image: PersonSearch2
  }
};
